var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('roe-error-message',{attrs:{"field":_vm.design.profit_sharing_allocation_method}},[_c('v-select',{attrs:{"name":"profit_sharing_allocation_method","options":[
      { code: 0, label: 'None' },
      { code: 1, label: 'Percent of Pay' },
      { code: 2, label: 'Flat dollar' },
      { code: 3, label: 'Integrated with social security' },
      { code: 4, label: 'Government contract (prevailing wage)' },
      { code: 5, label: 'Age weighted formula' },
      {
        code: 6,
        label: 'New comparability formula - individual groups'
      },
      {
        code: 7,
        label: 'New comparability formula - defined allocation groups'
      }
    ],"reduce":function (label) { return label.code; },"required":""},on:{"input":function($event){_vm.resetFormulaFields(), _vm.setEOY()}},model:{value:(_vm.design.$model.profit_sharing_allocation_method),callback:function ($$v) {_vm.$set(_vm.design.$model, "profit_sharing_allocation_method", _vm._n($$v))},expression:"design.$model.profit_sharing_allocation_method"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }